// Mock data for Nagisa Gaming Store - Free Fire accounts
export const SITE = {
  name: 'Nagisa Gaming Store',
  logo: 'https://i.postimg.cc/mZFWhGG4/erasebg-transformed-(6).png',
  telegram: 'https://t.me/Nagisa_Gaming',
  facebook: 'https://www.facebook.com/share/1EbD7AUKHD/',
};

export const FREE_FIRE_BANNER =
  'https://img.gamemarket.gg/public-folder/games/wallpapers/Wallpaper_FREEFIRE_GameMarketgg_1747272840_b8d711.webp';

export const GAMES = [
  { id: 'free-fire', name: 'Free Fire' },
  { id: 'pubg-mobile', name: 'PUBG Mobile' },
  { id: 'fortnite', name: 'Fortnite' },
  { id: 'mobile-legends', name: 'Mobile Legends' },
  { id: 'call-of-duty-mobile', name: 'Call of Duty Mobile' },
  { id: 'blood-strike', name: 'Blood Strike' },
];

export const CATEGORY_TABS = [
  { key: 'all', label: 'All', count: 66 },
  { key: 'accounts', label: 'Accounts', count: 33 },
  { key: 'top-up', label: 'Top Up', count: 33 },
  { key: 'boosting', label: 'Boosting', count: 0 },
  { key: 'hourly-services', label: 'Hourly Services', count: 0 },
  { key: 'others', label: 'Others', count: 0 },
];

export const SERVERS = [
  'All Server',
  'Indonesia (ID)',
  'Global',
  'India (IN)',
  'Brazil (BR)',
  'Middle East',
  'Thailand (TH)',
  'Vietnam (VN)',
];

export const SORT_OPTIONS = [
  { key: 'newest', label: 'Newest' },
  { key: 'oldest', label: 'Oldest' },
  { key: 'price-low', label: 'Price: Low to High' },
  { key: 'price-high', label: 'Price: High to Low' },
  { key: 'popular', label: 'Most Popular' },
];

const SELLERS = [
  { name: 'BangJohn', rating: 4.9, reviews: 315, avatar: 'https://img.gamemarket.gg/users/BangJohn/avatar-G4b.webp', online: true },
  { name: 'PUTRAAASTOREE', rating: 5.0, reviews: 12, avatar: 'https://img.gamemarket.gg/users/PUTRAAASTOREE/avatar-XEd.webp', online: true },
  { name: 'ressyadistok', rating: 5.0, reviews: 16, avatar: 'https://img.gamemarket.gg/users/ressyadistok/avatar-TVx.webp', online: false },
  { name: 'NagisaPro', rating: 4.8, reviews: 128, avatar: 'https://i.pravatar.cc/100?img=12', online: true },
  { name: 'FireLord99', rating: 4.7, reviews: 87, avatar: 'https://i.pravatar.cc/100?img=33', online: false },
];

const IMGS = [
  'https://img.gamemarket.gg/products/gxgglzzo/free-fire-accounts-indonesia-vault-147-m1887-handofhope-gurun-pasir-jlw-thumbnail.webp',
  'https://img.gamemarket.gg/products/vlapwv70/free-fire-accounts-indonesia-akun-murah-tapi-emot-gelap-1-murah-d-xik-thumbnail.webp',
  'https://img.gamemarket.gg/products/rm1rpwfx/free-fire-accounts-for-indonesia-set-budi-01-gaming-set-wisana-w64-thumbnail.webp',
  'https://img.gamemarket.gg/products/kewtugqw/free-fire-accounts-indonesia-sg-trompet-vault-rame-naruto-ada-3-j1e-thumbnail.webp',
  'https://img.gamemarket.gg/products/8lhj60lq/free-fire-accounts-indonesia-sg-terkuat-opm-reaper-max-2-otw-3-mbq-thumbnail.webp',
  'https://img.gamemarket.gg/products/lug6ogyh/free-fire-accounts-for-indonesi-akun-super-ghoib-langka-kemeja-zxs-thumbnail.webp',
  'https://img.gamemarket.gg/products/duuyafh2/free-fire-accounts-for-indonesia-bundle-berubah-max-1-bundle-n-rfb-thumbnail.webp',
  'https://img.gamemarket.gg/products/7obfseam/free-fire-accounts-for-indonesia-set-budi-01-gaming-set-wisana-cnh-thumbnail.webp',
  'https://img.gamemarket.gg/products/baukdcav/free-fire-accounts-indonesia-akun-sul-tan-max-3-otw-4-prime-5-koe-thumbnail.webp',
  'https://img.gamemarket.gg/products/vokaj0jc/free-fire-accounts-free-fire-sg2-emerald-power-m4a1-genos-ak47-uni-qp1-thumbnail.webp',
  'https://img.gamemarket.gg/products/irx1rkgk/free-fire-accounts-indonesia-m1887-rapper-underworld-mclaren-raci-4y8-thumbnail.webp',
  'https://img.gamemarket.gg/products/cjkjvfwy/free-fire-accounts-indonesia-2-evo-woodpecker-majestic-prowler-lv3-xwm-thumbnail.webp',
  'https://img.gamemarket.gg/products/noswl6kl/free-fire-accounts-indonesia-1-evo-woodpecker-majestic-prowler-lv4-cwz-thumbnail.webp',
  'https://img.gamemarket.gg/products/rxvb0zn9/free-fire-accounts-indonesia-2-evo-ump-lv5-m1014-lv6-m1887-aqu-ype-thumbnail.webp',
  'https://img.gamemarket.gg/products/q2olaoie/free-fire-accounts-indonesia-m1887-hand-of-hope-mamba-gnaw-m4a1-ven-95y-thumbnail.webp',
  'https://img.gamemarket.gg/products/rhbr4666/free-fire-accounts-indonesia-vault-46-sg-lumut-bundle-sukuna-jjk-im6-thumbnail.webp',
  'https://img.gamemarket.gg/products/ke232iee/free-fire-accounts-indonesia-2-evo-scar-megalodon-alpha-lv3-xm8-d-wg6-thumbnail.webp',
  'https://img.gamemarket.gg/products/y8lmdpgq/free-fire-accounts-indonesia-vault-1000-2-evo-ump-lv3-tinju-lv2-f1j-thumbnail.webp',
  'https://img.gamemarket.gg/products/lifdomop/free-fire-accounts-indonesia-m1887-handofhope-m1887-incendium-burst-sce-thumbnail.webp',
  'https://img.gamemarket.gg/products/cnfucfpf/free-fire-accounts-indonesia-2-evo-ak47-blue-flame-m1014-tutor-m1-use-thumbnail.webp',
];

const TITLES = [
  'Indonesia | Vault 147 | M1887-HandOfHope, Gurun Pasir, EmeraldPower | BunnyBackpack Lv.3 & BunnyMastermind Lv.3',
  'Indonesia | Akun murah tapi emot gelap 1 | murah dan bergaransi',
  'FOR INDONESIA | SET BUDI 01 GAMING | SET WISANA | OUTFIT TOTAL 1422 | BUNDLE NARUTO | BUNDLE BTS | EVO GUN 2',
  'Indonesia - SG Trompet - Vault Rame - Naruto ada 3, Anim Loby',
  'Indonesia | SG TERKUAT - OPM & REAPER | MAX 2 OTW 3 | LEVEL AKUN 68 | TOTAL OUTFIT 1.914',
  'FOR INDONESIA - AKUN SUPER GHOIB (LANGKA) - KEMEJA LANGKA - EMOT RAJA',
  'FOR INDONESIA - BUNDLE BERUBAH - MAX 1 - BUNDLE NARUTO - akun murah dan bagus - dana pelajar - cocok buat mabar',
  'FOR INDONESIA | SET BUDI 01 GAMING | SET WISANA | OUTFIT 1422 | BUNDLE NARUTO | BUNDLE BTS | EVO GUN 2',
  'INDONESIA | AKUN SUL TAN - MAX 3 OTW 4 | PRIME 5 | SG LUMUT | SG MATA ELANG',
  'FREE FIRE | SG2 EMERALD POWER, M4A1 GENOS, AK47 UNICORN LAVA, MP40 FLASHING SPEED, VAULT 329, CHEAPEST',
  'Indonesia | M1887 - RAPPER UNDERWORLD | McLaren Racing Bundle & Backpack | Thrash Metalic Backpack',
  'Indonesia | 2 EVO (Woodpecker Majestic Prowler Lv3, M60 Dreambreaker Lv3) | Backpack Dream Palace',
  'Indonesia | 1 EVO (WOODPECKER-MAJESTIC PROWLER Lv4) | M1887- HAND OF HOPE | Electrify Bunny Backpack',
  'Indonesia | 2 EVO (UMP Lv5, M1014 Lv6) | M1887- Aqua Burst | 2 Bunny Backpack | Naruto Bundle: Jiraiya',
  'Indonesia | M1887-Hand Of Hope & Mamba Gnaw | M4A1-Venom Netherworld | SuperGamer Bundle | Bunny Backpack Lv.3',
  'Indonesia | Vault 46 | SG Lumut | Bundle Sukuna JJK | Kaki Nyeker | Tas Bunny | Emote Lag',
  'Indonesia | 2 EVO (SCAR Megalodon Alpha Lv3, XM8 Destiny Guardian Lv4) | Backpack Wolf in Red | Weapon Skin 147',
  'Indonesia | Vault 1000 | 2 EVO (UMP Lv3, Tinju Lv2) | M1887- Mamba Gnaw | Electrify Bunny Backpack, Any Skins',
  'Indonesia | M1887-HandOfHope & M1887-Incendium Burst | Bunny Backpack Lv.3 | Bundle JJK',
  'Indonesia | 2 Evo: AK47-Blue Flame & M1014-TUTOR, M1887-EmeraldPower | BunnyBackpack Lv.3 & BunnyMastermind',
];

const PRICES = [
  95.5, 6.5, 10.73, 74.25, 7.43, 15.9, 12.1, 10.73, 28.88, 8.6,
  22.4, 19.75, 18.5, 24.9, 16.72, 7.79, 8.37, 7.81, 9.5, 13.2,
];

export const ACCOUNTS = TITLES.map((title, i) => ({
  id: `ff-${i + 1}`,
  slug: `free-fire-account-${i + 1}`,
  title,
  image: IMGS[i],
  price: PRICES[i],
  seller: SELLERS[i % SELLERS.length],
  server: 'Indonesia (ID)',
  type: 'Accounts',
  category: 'accounts',
  description:
    'Verified Free Fire account. Includes rare bundles, evo maxed skins, high vault count and premium outfits. Full binding transfer, screenshots verified. Instant delivery via Telegram after payment.',
  details: {
    'Account Level': 60 + (i % 15),
    'Vault': [147, 46, 329, 1000, 250][i % 5],
    'Rank': ['Heroic', 'Grandmaster', 'Diamond', 'Master'][i % 4],
    'Bundles': 5 + (i % 20),
    'Evo Guns': 1 + (i % 4),
    'Diamonds': 500 + (i * 137) % 5000,
    'Region': 'Indonesia',
    'Binding': 'Facebook / Guest',
  },
  gallery: [IMGS[i], IMGS[(i + 1) % IMGS.length], IMGS[(i + 2) % IMGS.length], IMGS[(i + 3) % IMGS.length]],
}));

export const NEWS = [
  {
    id: 1,
    title: 'Free Fire Skill Combination Guide | Aggressive & Defensive Meta',
    date: '5 Jul',
    image: 'https://img.gamemarket.gg/news/free-fire-skill-combination-guide-aggressive-defensive-meta_260705-tt-thumbnail.webp',
    excerpt: "Dominate Garena Free Fire's latest ranked season! Master the new character skill meta, discover the most overpowered combinations...",
  },
  {
    id: 2,
    title: 'Free Fire Underwater Update: Patch Notes & Meta Guide',
    date: '25 Apr',
    image: 'https://img.gamemarket.gg/news/free-fire-underwater-update-patch-notes-meta-guide_260425-JR-thumbnail.webp',
    excerpt: 'Dive into the latest Free Fire Underwater Mystery update! Discover the all-new Hydro Blasters, the powerful character...',
  },
  {
    id: 3,
    title: 'Ray "The Watchman" Info: Everything About the New OB53 Hero',
    date: '8 Apr',
    image: 'https://img.gamemarket.gg/news/ray-the-watchman-info-everything-about-the-new-ob53-hero_260408-WQ.webp',
    excerpt: "Dominate the battlefield with Ray, the newest entry fragger in Free Fire's OB53 update! Our comprehensive guide covers...",
  },
];

export const SIMILAR_MARKETS = [
  { id: 'fortnite', name: 'Fortnite', img: 'https://img.gamemarket.gg/markets/fortnite/fortnite-thumbnail_260417-FN.webp', tags: [{ label: 'Hourly Services', count: 37 }, { label: 'Accounts', count: 2 }] },
  { id: 'pubg-mobile', name: 'PUBG Mobile', img: 'https://img.gamemarket.gg/markets/pubg-mobile/pubg-mobile-thumbnail_260422-W3.webp', tags: [{ label: 'Top Up', count: 7 }, { label: 'Others', count: 2 }] },
  { id: 'pubg', name: 'PUBG', img: 'https://img.gamemarket.gg/markets/pubg-playerunknowns-battlegrounds/pubg-playerunknowns-battlegrounds-thumbnail_260422-kW.webp', tags: [{ label: 'Accounts', count: 1 }] },
  { id: 'blood-strike', name: 'Blood Strike', img: 'https://img.gamemarket.gg/markets/blood-strike/blood-strike-thumbnail_260410-iO.webp', tags: [{ label: 'Accounts', count: 1629 }, { label: 'Hourly', count: 37 }] },
];
